import styled from 'styled-components';
import { Button } from 'react-bootstrap';

export const StyledMobileBoxItem = styled.div`
  border: 1px solid #dadce0;
  margin-bottom: 15px;
  padding: 10px;
  padding-bottom: 15px;
  font-size: 14px;
  position: relative;
`;

export const StyledMobileBoxItemRow = styled.div`
  display: ${props => (props.isEditableRow ? 'flex' : 'block')};
  flex-wrap: ${props => (props.isMobileEditMode ? 'nowrap' : 'wrap')};
  align-items: center;
  margin-bottom: 15px;
  font-weight: 600;
  max-width: ${props => props.maxWidth || '60%'};
  word-break: break-word;

  span {
    font-weight: 400;
  }

  .field-label {
    width: 120px;
  }

  div,
  span,
  input,
  textarea {
    font-weight: 400;
  }

  input,
  textarea {
    padding: 5px 10px;
    border-color: #e7e7e7;
    border: 1px solid #e7e7e7;
    margin-left: 5px;
    width: 60%;
  }
`;

export const StyledMobileBoxLabel = styled.div`
    font-size: 14px; 
    position: absolute;
    right: ${props => props.right || '10px'}
    top: 10px;
    color: #cccccc;
    max-width: 35%;
    word-break: break-word;
`;

export const StyledMobileBoxSelectableItem = styled(StyledMobileBoxItemRow)`
     div {
        font-weight: 400;
     }
     
     span {
        font-weight: 600;
        display: block
        margin-bottom: 5px;
     }
`;

export const StyledMobileBoxRemoveButton = styled.button`
    position: absolute;
    right: 5px;
    top: 8px;
    
    border: none;
    outline: none;
    
    width: 25px;
    height: 25px;
    
    border-radius: 50px
    
    color: #ffffff;
    background: #808080;
    margin: 0;
    padding: 0;
    
    &::before {
      display: inline-block;
      content: "\\00d7"; 
      font-weight: 600;
      font-size: 27px;
      position: absolute;
      top: -6px;
      left: 0;
      right: 0;
      margin: auto;
    }
`;

export const StyledMobileBoxSaveButton = styled(Button)`
  &&& {
    width: 60px;
    height: 35px;

    background: #ffffff;
    color: #b52666;
    border: 1px solid #b52666;
    margin-left: 10px;
  }
`;
